module.exports = __webpack_public_path__ + "static/media/left-arrow.4bff3cc5.svg";